import { render, staticRenderFns } from "./TaskTypeDrawer.vue?vue&type=template&id=642ba0e4&scoped=true&"
import script from "./TaskTypeDrawer.vue?vue&type=script&lang=js&"
export * from "./TaskTypeDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642ba0e4",
  null
  
)

export default component.exports